// Remix-mode Aeon Powers, in the 12 packs of four the game awards them in ("Aeon Powers Collected:"
// messages in the string table). Names match the save's `Aeon` array entries.
export const AEON_PACKS = [
  ["Auto-Logger", "Debris Scope", "Velocity Beam", "Aqua-Recovery"],
  ["Offensive Boost", "Seeker Beam", "Seeker Missile", "Maximum Power"],
  ["Chain Missile", "Boost-Sprint", "Swift Boots", "Speed-Ball"],
  ["Blazing Spider", "Proximity Beam", "Quick Bombs", "Flare Ball"],
  ["Reinforced Suit", "Energy Generator", "Missile Generator", "Power Bomb Generator"],
  ["Gatling Beam", "Blaze Missile", "Frost Missile", "Shock Missile"],
  ["Static Power Bomb", "Flare Power Bomb", "Frost Power Bomb", "Hefty Beam"],
  ["Bountiful Pickups", "Static Bomb", "Flare Bomb", "Frost Bomb"],
  ["Chip Bomb", "Charge Module", "Mine Bomb", "Side-Dash"],
  ["Damage Discharge", "Boost Extender", "Boost Charger", "Pickup-Poison"],
  ["Cleeted Boots", "Screw Inferno", "Screw Shock", "Screw Blizzard"],
  ["Death Ball", "Phazon Shield", "Phazon Generator", "Ricochet Cannon"],
]

export const AEON_POWERS = AEON_PACKS.flat()
